import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';
import { LookupType, RepellType } from 'app/enum/Particles';
import { HomeParticle } from 'app/views/home/webgl/particles/fields/HomeParticle';
import DelayHelper from 'utils/timers';
import HomeColours from 'app/views/home/config/HomeColours';

export default class IconParticleProcessor {
	private _nonDragEase: geometry.Vector2;
	private _isDragging: boolean = false;

	private _repellActiveDragFlag: boolean = true;

	constructor(
		private _p: HomeParticle,
		private _sceneProps: particles.ParticlesSceneProps
	) {}

	public switchHomeEffect(power) {
		this._p.counter.active = true;
		this._p.counter.triggerAtFrames = 60 + Math.round(Math.random() * 360);
		this._p.repell.active = true;
		this._triggerHomeEffectSwitch();
	}

	/** Set the particle home icon state for behaviour as D icon  */
	public initIcon(reset: boolean = true): void {
		this._p.repell.target = this._sceneProps.targets.homeMouse;

		this._p.position.disableTimelineX = true;

		this._p.particleProps.sprite.blendMode = 'add';

		this._p.colourise(-2);

		let isSmall = Math.random() < 0.75 ? true : false;

		if (reset) {
			this._p.deactivateAllBehaviours(true);
		}

		let shape = 'solid2.png';
		let ran = Math.random();
		if (ran < 0.06) {
			shape = 'solid-tri.png';
			this._p.orbitPath.syncRotation = true;
		} else if (ran < 0.12) {
			shape = 'solid-tri2.png';
			this._p.orbitPath.syncRotation = true;
		}

		this._p.changeParticle(shape);

		this._p.animatedProps.hardSetScale(0.2);

		this._p.position.trackMouse = false;
		this._p.mouseParallax.active = false;
		this._p.repell.active = false;

		this._p.mouseParallax.active = false;
		let ease = 12 + Math.random() * 12;
		ease = 12;
		this._p.animatedProps.setEase({
			x: ease,
			y: ease,
			scale: 20
		});

		this._nonDragEase = {
			x: ease,
			y: ease
		};

		//Allow for 150px circle and very tight ring:
		this._p.repell.randomisePower(30, 80);

		this._p.orbitPath.active = false;
		this._p.position.trackMouse = false;
		this._p.orbitPath.expandMuliplier = 1;

		this._p.repell.target = this._sceneProps.targets.homeMouse;
		this._p.repell.type = RepellType.PUSH;
		this._p.repell.testAtCount = 1;
		//Allow for 150px circle and very tight ring:
		this._p.repell.radius = 50;
		this._p.repell.randomisePower(50, 10);
		this._p.repell.active = true;

		//Lamp / Hover effect:

		if (!isSmall) {
			if (Math.random() < 0.15) {
				this._p.colour.set(HomeColours.getRandomColour(HomeColours.greenBlues));
				this._p.animatedProps.targetScale = this._p.random(0.15, 0.35);
				this._p.animatedProps.targetAlpha = this._p.random(0.5, 0.3);
			} else {
				this._p.colour.set('#fff');
				this._p.animatedProps.targetScale = this._p.random(0.1, 0.25);
				this._p.animatedProps.targetAlpha = this._p.random(0.1, 0.4);
			}
		} else {
			if (Math.random() < 0.2) {
				this._p.colour.set(HomeColours.getRandomColour(HomeColours.greenBlues));
				this._p.animatedProps.targetAlpha = this._p.random(0.4, 0.2);
			} else {
				this._p.colour.set('#fff');
				this._p.animatedProps.targetAlpha = this._p.random(0.1, 0.4);
			}

			this._p.animatedProps.targetScale = this._p.random(0.08, 0.08);
		}

		this._triggerHomeEffectSwitch();

	}

	/** When dragging then make the particles follow the scene without easing */
	public startSceneDrag() {
		return;
		this._isDragging = true;

		this._repellActiveDragFlag = this._p.repell.active;
		this._p.repell.active = false;

		this._p.animatedProps.setEase({ x: 2 }, false);
	}

	/** When dragging stops can restart normal easing */
	public endSceneDrag() {
		return;
		this._isDragging = false;

		this._p.repell.active = this._repellActiveDragFlag;

		if (!this._nonDragEase) {
			return;
		}

		this._p.animatedProps.setEase(
			{
				x: this._nonDragEase.x,
				y: this._nonDragEase.y
			},
			true,
			20
		);
	}

	//PRIVATE
	//-------------------------------------------------------------------------------------------------------------
	//-------------------------------------------------------------------------------------------------------------
	//-------------------------------------------------------------------------------------------------------------
	//-------------------------------------------------------------------------------------------------------------



	public increaseOrbitExpand() {
		if (this._p.orbitPath.expandMuliplier < 27) {
			this._p.orbitPath.expandMuliplier += 0.1;
		}
	}

	private _triggerHomeEffectSwitch() {
		let ease = 20 + Math.random() * 30;

		let initEase = this._isDragging ? 2 : ease;

		this._p.animatedProps.setEase({
			x: initEase,
			y: ease,
			scale: 40
		});

		this._nonDragEase = {
			x: ease,
			y: ease
		};


		this._p.random(0, 0);



		this._p.repell.active = true;

		this._p.orbitPath.active = true;
		this._p.orbitPath.expandMuliplier = 1;
		this._p.orbitPath.path = LookupType.CIRCLE;
		this._p.orbitPath.speed = 1;
		this._p.orbitPath.speedMuiliplier = 0.1;
		this._p.orbitPath.scaleActive = false;
		this._p.orbitPath.alphaActive = false;



		this._p.animatedProps.startBreathing(this._p.animatedProps.targetScale, Math.random() * 0.03, Math.random() * 0.3);

		DelayHelper.setTimeout(() => {
			this._p.orbitPath.xMuliplier = this._p.random(0, 10);
			this._p.orbitPath.yMuliplier = this._p.random(0, 10);
			this._p.orbitPath.active = true;
		}, 20);



	}
}
